import { render, staticRenderFns } from "./PreferredWorkRegion.vue?vue&type=template&id=0a4dc43a"
import script from "./PreferredWorkRegion.vue?vue&type=script&lang=js"
export * from "./PreferredWorkRegion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports